var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolume(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1791_47401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.29 1.23602L4.36 7.16602C4.36 7.16602 4.25 7.23602 4.18 7.23602H2C0.9 7.23602 0 8.13602 0 9.23602V12.646C0 13.746 0.9 14.646 2 14.646H4.19C4.26 14.646 4.32 14.676 4.37 14.716L10.3 20.646C10.59 20.936 11.02 21.016 11.39 20.866C11.76 20.716 12.01 20.346 12.01 19.946V1.94602C12.01 1.53602 11.77 1.17602 11.39 1.01602C11.02 0.856022 10.58 0.946022 10.3 1.23602H10.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.58 3.91677C17.19 3.53677 16.56 3.54677 16.18 3.92677C15.79 4.31677 15.79 4.93677 16.17 5.32677C17.66 6.81677 18.5 8.83677 18.5 10.9468C18.5 13.0568 17.66 15.0768 16.17 16.5668C15.79 16.9568 15.8 17.5868 16.18 17.9668C16.57 18.3568 17.19 18.3568 17.58 17.9768C19.45 16.1168 20.49 13.5768 20.49 10.9468C20.49 8.31677 19.44 5.77677 17.58 3.91677Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1401 6.44674C14.8901 6.17674 14.5201 6.05674 14.1601 6.14674C13.8001 6.23674 13.5201 6.51674 13.4301 6.87674C13.3401 7.23674 13.4501 7.61674 13.7301 7.85674C15.4301 9.56674 15.4301 12.3267 13.7301 14.0367C13.4601 14.2867 13.3601 14.6567 13.4501 15.0167C13.5401 15.3667 13.8201 15.6467 14.1701 15.7367C14.5201 15.8267 14.9001 15.7167 15.1501 15.4467C17.6301 12.9567 17.6301 8.93674 15.1501 6.44674H15.1401Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1791_47401"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.5,
    height: 20,
    fill: "white",
    transform: "translate(0 0.946289)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/volume.eab0dc27635df8baa2bd1d0b53d421f1.svg";
export { ForwardRef as ReactComponent };